<template>
  <div
    class="gutter-sm"
    :class="$q.screen.lt.md && !showFiltersMobile ? 'column' : 'row'"
  >
    <div
      v-if="withFilters && ($q.screen.lt.md || showFiltersDesktop)"
      :class="$q.screen.lt.md && !showFiltersMobile ? 'col-auto' : 'col-md-3'"
    >
      <q-card :class="$q.screen.gt.sm ? 'full-height' : ''">
        <q-card-title>
          <div class="row">
            <div class="col">
              Filters
            </div>
            <div
              v-if="$q.screen.lt.md"
              class="col-auto q-mr-auto"
            >
              <q-btn
                color="secondary"
                flat
                round
                :icon="`keyboard_arrow_${showFiltersMobile ? 'up' :'down'}`"
                @click="toggleFiltersMobile"
              />
            </div>
          </div>
        </q-card-title>
        <q-card-main
          v-if="$q.screen.gt.sm || showFiltersMobile"
          style="height: calc(100% - 64px)"
        >
          <q-scroll-area
            v-if="$q.screen.gt.sm"
            class="full-height"
          >
            <bj-filters
              ref="filtersModal"
              :key="filtersResetReRenderKey"
              v-model="filters"
              :fields="filterFields"
              :statuses="$config.tourStatuses"
              @reset="filtersResetReRenderKey++"
              @input="initPage1"
            />
          </q-scroll-area>
          <bj-filters
            v-else
            :key="filtersResetReRenderKey"
            ref="filtersModal"
            v-model="filters"
            :fields="filterFields"
            :statuses="$config.tourStatuses"
            @reset="filtersResetReRenderKey++"
            @input="initPage1"
          />
        </q-card-main>
      </q-card>
    </div>
    <div class="col">
      <q-table
        ref="quasarTable"
        :data="tours"
        :columns="columns"
        :visible-columns="visibleColumns"
        separator="cell"
        class="sticky-header-table"
        row-key="id"
        color="primary"
        :loading="loading"
        no-data-label="Tours not found"
        no-results-label="Tours not found"
        loading-label="Fetching tours..."
        :pagination.sync="pagination"
        :rows-per-page-options="[25, 50, 100, 250]"
        @request="request"
      >
        <template
          slot="top-left"
          slot-scope="props"
        >
          <div v-if="$q.screen.gt.sm">
            <q-btn
              v-if="withFilters"
              v-tippy
              rounded
              icon="filter_list"
              color="secondary"
              title="Show/Hide filters"
              class="q-mr-md"
              @click.native="toggleFiltersDesktop"
            />
          </div>
        </template>
        <template
          slot="bottom-row"
          slot-scope="props"
        >
          <div
            class="q-mr-sm font-small"
          >
            Displaying {{ totalResults }} tours
          </div>
        </template>
        <template
          slot="body-cell-id"
          slot-scope="props"
        >
          <q-td :props="props">
            {{ props.value }}
          </q-td>
        </template>
        <template
          slot="body-cell-schedule"
          slot-scope="props"
        >
          <q-td :props="props">
            {{ props.value }}
          </q-td>
        </template>
        <template
          slot="body-cell-property"
          slot-scope="props"
        >
          <q-td :props="props">
            <router-link :to="{ name: 'app.properties.combined', params: { id: props.value.id } }">
              {{ props.value.short_address }}
            </router-link>
          </q-td>
        </template>
        <template
          slot="body-cell-unit"
          slot-scope="props"
        >
          <q-td :props="props">
            <span>{{ props.value.name }}</span>
          </q-td>
        </template>
        <template
          slot="body-cell-leads"
          slot-scope="props"
        >
          <q-td :props="props">
            <div
              v-for="(scheduleInquiry, index) in props.row.schedule_inquiries"
              :key="index"
            >
              <SdLeadFullName
                :lead="scheduleInquiry.inquiry.lead"
              />
            </div>
          </q-td>
        </template>
        <template
          slot="body-cell-agent"
          slot-scope="props"
        >
          <q-td :props="props">
            <span v-if="get(props, 'value.id') && !props.row.is_taken_over && !props.row.is_self_showing">
              <router-link :to="{ name: 'app.agents.profile', params: { id: props.value.id } }">
                {{ props.value.full_name }}
              </router-link>
              <i
                v-if="props.value.blocked"
                class="ml-1 text-red q-icon fa fa-ban"
              />
            </span>
            <q-chip
              v-else-if="props.row.is_taken_over"
              color="purple-4"
              class="capitalize"
            >
              Taken Over
            </q-chip>
            <q-chip
              v-else-if="props.row.is_self_showing"
              color="purple-4"
              class="capitalize"
            >
              Self Showing
            </q-chip>
            <span v-else>
              N/A
            </span>
          </q-td>
        </template>
        <template
          slot="body-cell-inquiryIds"
          slot-scope="props"
        >
          <q-td :props="props">
            <router-link
              v-for="(id, index) in props.value"
              :key="index"
              :to="{ name: 'app.inquiries.timeline', params: { id } }"
            >
              <q-btn
                rounded
                outline
                size="sm"
                color="primary"
                :label="id"
              />
            </router-link>
          </q-td>
        </template>
        <template
          slot="body-cell-status"
          slot-scope="props"
        >
          <q-td :props="props">
            <q-chip class="capitalize">
              {{ props.value.split('_').join(' ') }}
            </q-chip>
            <q-chip
              v-if="props.row.is_showami"
              dense
              class="ml-2"
              color="orange"
              text-color="white"
            >
              Showami
            </q-chip>
            <a
              v-if="props.row.is_showami && props.row.tour_url"
              class="ml-2"
              :href="props.row.tour_url"
              target="_blank"
            >🈶</a>
          </q-td>
        </template>
        <template
          slot="body-cell-showingType"
          slot-scope="props"
        >
          <q-td :props="props">
            {{ props.row.showing_profile_type }}
          </q-td>
        </template>
        <template
          slot="body-cell-reviews"
          slot-scope="props"
        >
          <q-td
            :class="props.value.length > 1 ? 'p-1' : ''"
            :props="props"
          >
            <div
              v-for="(review, index) in props.value"
              :key="index"
            >
              <q-rating
                v-model="review.score"
                readonly
              />
              <q-icon
                v-if="props.value.length > 1"
                v-tippy
                name="info"
                size="16px"
                color="blue"
                :title="'Lead ID: #' + review.owner_model_id"
              />
              <q-icon
                v-if="review.review"
                v-tippy
                name="comment"
                size="15px"
                :title="review.review"
              />
            </div>
          </q-td>
        </template>
        <template
          slot="body-cell-tour_at"
          slot-scope="props"
        >
          <q-td :props="props">
            <SdDatetime
              :value="props.row.tour_at"
              :until="props.row.tour_until"
              :market-id="props.row.property.market_id"
              :timezone="props.row.property.timezone"
            />
            <i
              v-if="props.row.is_video"
              class="q-icon fa fa-video"
              style="margin-left: 5px"
            />
            <i
              v-if="props.row.is_open_house"
              class="q-icon fa fa-users"
              style="margin-left: 5px"
            />
          </q-td>
        </template>
        <template
          slot="body-cell-City"
          slot-scope="props"
        >
          <q-td :props="props">
            <span v-if="props.row.property.address.data">{{ props.row.property.address.data.vicinity }}</span>
          </q-td>
        </template>
        <template
          slot="body-cell-transactionId"
          slot-scope="props"
        >
          <q-td :props="props">
            <q-btn
              v-if="props.row.transactionId"
              rounded
              outline
              size="sm"
              color="primary"
              :label="props.row.transactionId"
              @click="redirect('app.transactions', { id: props.row.transactionId })"
            />
            <q-btn
              v-if="props.row.chargeTransactionId"
              rounded
              outline
              size="sm"
              color="primary"
              :label="props.row.chargeTransactionId"
              @click="redirect('app.transactions', { id: props.row.chargeTransactionId })"
            />
          </q-td>
        </template>
        <template
          slot="body-cell-Market"
          slot-scope="props"
        >
          <q-td :props="props">
            <span v-if="props.row.property.market">
              {{ props.row.property.market.name }}
            </span>
          </q-td>
        </template>
        <template
          slot="body-cell-actions"
          slot-scope="props"
        >
          <q-td :props="props">
            <q-btn
              v-if="props.row.survey_result_id || props.row.timed_out_at"
              v-tippy
              :to="{ name: 'app.tours.survey-result', params: { id: props.row.id }}"
              size="sm"
              rounded
              outline
              color="info"
              icon="view_list"
              title="Survey result"
              class="q-ml-sm"
            />
            <q-btn
              v-if="userRoleIs($config.roles.SUPER_ADMIN, $config.roles.ADMIN) && props.row.status === $config.tourStatuses.PENDING"
              v-tippy
              rounded
              push
              color="negative"
              size="sm"
              class="q-ml-sm"
              outline
              icon="cancel"
              :title="props.row.is_open_house ? 'Cancel Open House' : 'Cancel tour'"
              @click="openCancelTourConfirm(props.row)"
            />
            <q-btn
              v-if="userRoleIs($config.roles.SUPER_ADMIN, $config.roles.ADMIN) && props.row.status === $config.tourStatuses.PENDING && !props.row.survey_result_id"
              :to="{ name: 'app.tours.after-tour-survey', params: { tourId: props.row.id } }"
              class="q-ml-sm"
              color="green"
              size="sm"
              rounded
              label="submit report"
              icon="done"
              outline
            />
          </q-td>
        </template>

        <template
          slot="top-right"
          slot-scope="props"
        >
          <div
            v-if="$q.screen.gt.sm"
            class="row items-center full-width"
          >
            <div
              v-if="!$q.screen.lt.lg"
              class="col-auto"
            >
              <q-table-columns
                ref="hello"
                v-model="visibleColumns"
                class="full-width"
                color="black"
                label="Visible Columns"
                :columns="columns"
                @input="visibleColumnsChanged"
              />
            </div>
            <div class="col-auto">
              <q-btn
                rounded
                flat
                label="Reload data"
                icon="refresh"
                color="black"
                @click="init"
              />
            </div>
            <div class="col">
              <q-btn
                round
                flat
                color="black"
                :icon="props.toggleFullscreen ? 'fullscreen_exit' : 'fullscreen'"
                @click="props.toggleFullscreen"
              />
            </div>
          </div>
        </template>
        <div
          slot="pagination"
          slot-scope="props"
          class="row flex-center q-py-sm"
        >
          <q-btn
            dense
            size="sm"
            icon="arrow_back"
            rounded
            color="primary"
            class="q-mr-sm"
            :disable="(hasUnknownTotal ? !hasPrevPage : props.isFirstPage)"
            @click="props.prevPage()"
          />
          <div
            class="q-mr-sm font-small m-4"
          >
            <span v-if="!hasUnknownTotal">Page {{ props.pagination.page }} / {{ props.pagesNumber }}</span>
            <span v-else>Page {{ props.pagination.page }}</span>
          </div>
          <q-btn
            rounded
            dense
            size="sm"
            icon="arrow_forward"
            color="primary"
            :disable="(hasUnknownTotal ? !hasNextPage : props.isLastPage)"
            @click="props.nextPage()"
          />
        </div>
      </q-table>
    </div>
  </div>
</template>

<script>
import get from 'lodash.get';
import { ShowingTypesDisplay } from '@/constants/ShowingProfile';
import SdLeadFullName from '@/components/common/SdLeadFullName';
import BjFilters from './filters';

export default {
  components: {
    SdLeadFullName,
    BjFilters,
  },
  props: {
    propertyId: {
      type: Number,
      required: false,
    },
    unitId: {
      type: Number,
      required: false,
    },
    filterById: {
      type: Number,
      required: false,
    },
    filterByAgentId: {
      type: Number,
      required: false,
    },
    withFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
    withAgentFilter: {
      type: Boolean,
      required: false,
      default: true,
    },
    tableName: {
      type: String,
      default() {
        return this.$route.name === 'app.tours' ? 'Tours' : 'AgentsProfile';
      },
    },
  },
  data() {
    let columns = [
      {
        name: 'id',
        field: 'id',
        label: 'ID',
        sortable: false,
      },
      {
        name: 'schedule',
        field: 'schedule_id',
        label: 'Schedule ID',
        sortable: false,
      },
    ];
    const filterFields = ['date', 'status', 'tours', 'markets', 'showing_type', 'schedule_id', 'is_showami'];

    if (this.withAgentFilter) {
      filterFields.splice(2, 0, 'agents');
    }

    if (typeof this.propertyId === 'undefined' && typeof this.unitId === 'undefined') {
      columns.push({
        name: 'property',
        field: 'property',
        label: 'Property',
        sortable: false,
      });

      filterFields.push('properties');
    }

    if (typeof this.unitId === 'undefined') {
      columns.push({
        name: 'unit',
        field: 'unit',
        label: 'Unit',
        sortable: false,
      });
    }

    if (this.userRoleIs(this.$config.roles.SUPER_ADMIN, this.$config.roles.ADMIN)) {
      filterFields.push('businesses');
      columns.push({
        name: 'inquiryIds',
        field: 'inquiryIds',
        label: 'Inquiry IDs',
        sortable: false,
      });
    }

    columns.push({
      name: 'status',
      field: 'status',
      label: 'Status',
      sortable: false,
    });

    columns.push({
      name: 'showingType',
      field: 'showingType',
      label: 'Showing Type',
      sortable: false,
    });

    if (this.$route.name === 'app.tours') {
      columns.push({
        name: 'agent',
        field: 'agent',
        label: 'Agent',
        sortable: false,
      });
    }

    columns = [
      ...columns,
      {
        name: 'leads',
        field: 'leads',
        label: 'Leads',
        sortable: false,
      },
      {
        name: 'reviews',
        field: 'reviews',
        label: 'Agent ratings',
        sortable: false,
      },
      {
        name: 'tour_at',
        field: 'tour_at',
        label: 'Tour at',
        sortable: false,
      },
      {
        name: 'City',
        field: 'City',
        label: 'City',
        sortable: false,
      },
      {
        name: 'Market',
        field: 'Market',
        label: 'Market',
        sortable: false,
      },
    ];

    if (this.userRoleIs(this.$config.roles.SUPER_ADMIN, this.$config.roles.ADMIN)) {
      columns.push({
        name: 'payout',
        field: 'payout',
        label: 'Payout',
        sortable: false,
      });
      columns.push({
        name: 'transactionId',
        field: 'transactionId',
        label: 'Transaction ID',
        sortable: false,
      });
    }

    columns.push({
      name: 'actions',
      field: 'actions',
      label: this.userRoleIs(this.$config.roles.SUPER_ADMIN, this.$config.roles.ADMIN) ? 'Actions' : 'Tour Report',
      sortable: false,
    });

    columns = columns.map((column) => ({
      ...column,
      align: 'left',
    }));

    const visibleColumns = columns.map((column) => column.name);

    return {
      loading: true,
      error: false,
      tours: [],
      filtersResetReRenderKey: 1,
      columns,
      visibleColumns,
      filters: {
        from_date: null,
        to_date: null,
        status: [],
        agents: [],
        tours: this.filterById ? [this.filterById] : [],
        properties: this.$route.query.property_id ? [this.$route.query.property_id] : [],
        units: this.$route.query.unit_id ? [this.$route.query.unit_id] : [],
        businesses: [],
        markets: [],
        scheduleId: null,
        showingType: null,
        is_showami: false,
      },
      filterFields,
      showFiltersMobile: false,
      showFiltersDesktop: false,
      pagination: {
        page: 1,
        rowsNumber: 999999999,
        rowsPerPage: 25,
      },
      totalResults: null,
      hasUnknownTotal: true,
      hasNextPage: false,
      hasPrevPage: false,
    };
  },
  created() {
    this.visibleColumns = this.$store.getters['app/dataTableConfig'](this.tableName, 'visibleColumns') || this.visibleColumns;
    this.pagination.rowsPerPage = this.$store.getters['app/dataTableConfig'](this.tableName, 'rowsPerPage') || this.pagination.rowsPerPage;

    this.init();
  },
  methods: {
    init(refresh) {
      if (refresh) {
        this.loading = true;
        this.error = true;
      }
      this.fetchTours(this.pagination.page).then((response) => {
        this.totalResults = response.total;
        this.tours = response.data.map((tour) => {
          const scheduleInquiries = tour.schedule.schedule_inquiries.length
            ? tour.schedule.schedule_inquiries
            : tour.schedule.deleted_schedule_inquiries;
          tour = {
            id: tour.id,
            schedule_id: tour.schedule.id,
            property: tour.property,
            unit: tour.unit,
            status: this.resolveTourStatus(tour.status),
            agent: tour.user,
            is_taken_over: tour.is_taken_over,
            is_self_showing: tour.is_self_showing,
            is_open_house: tour.is_open_house,
            is_showami: tour.is_showami,
            tour_url: `https://${tour.tour_url}`,
            schedule_inquiries: scheduleInquiries,
            reviews: tour.reviews,
            tour_at: tour.tour_at,
            tour_until: tour.tour_until,
            is_video: tour.schedule.is_video,
            inquiryIds: scheduleInquiries.map((scheduleInquiry) => scheduleInquiry.inquiry_id),
            transactionId: tour.transaction && !tour.is_taken_over ? tour.transaction.id : '',
            chargeTransactionId: tour.charge_transaction && !tour.is_taken_over ? tour.charge_transaction.id : '',
            payout: tour.transaction ? `$${tour.transaction.amount}` : '',
            survey_result_id: tour.survey_result_id,
            timed_out_at: tour.timed_out_at,
            showing_profile_type: ShowingTypesDisplay[tour.showing_profile.type],
          };

          return tour;
        });
        const hasTotal = response && response.total != null;
        this.hasUnknownTotal = !hasTotal;
        this.pagination.rowsNumber = hasTotal ? response.total : 999999999;
        this.hasNextPage = !!(response && response.next_page_url);
        this.hasPrevPage = !!(response && response.prev_page_url);
        if (response && response.per_page != null) {
          this.pagination.rowsPerPage = parseInt(response.per_page);
        }
        this.loading = false;
      }).catch((error) => {
        this.error = error;
      });
    },
    resolveTourStatus(status) {
      if (this.$config.tourStatuses.TIME_OUT === status) {
        return this.$config.tourStatusesDisplayable.TIME_OUT;
      }
      return status;
    },
    request({ pagination }) {
      this.pagination = pagination;
      this.init();
    },
    fetchTours(page = 1) {
      if (this.pagination.rowsPerPage !== this.$store.getters['app/dataTableConfig'](this.tableName, 'rowsPerPage')) {
        this.$store.commit('app/SET_DATA_TABLE_CONFIG', {
          name: this.tableName,
          key: 'rowsPerPage',
          value: this.pagination.rowsPerPage,
        });
      }

      if (!this.filters.properties.length) {
        const query = { ...this.$route.query };
        delete query.property_id;
        delete query.unit_id;
        this.$router.replace({ query });
        this.filters.units = [];
      }

      const params = {
        page,
        limit: this.pagination.rowsPerPage,
        per_page: this.pagination.rowsPerPage,
        id: this.filters.tours,
        status: this.filters.status,
        user_id: this.filters.agents,
        property_id: this.filters.properties,
        unit_id: this.filters.units,
        business_id: this.filters.businesses,
        markets: this.filters.markets,
        schedule_id: this.filters.scheduleId,
        from_date: this.filters.from_date ? this.moment(this.filters.from_date).tz(this.moment.tz.guess()).utc().format('YYYY-MM-DD HH:mm:ss') : null,
        to_date: this.filters.to_date ? this.moment(this.filters.to_date).tz(this.moment.tz.guess()).utc().format('YYYY-MM-DD HH:mm:ss') : null,
        showing_type: this.filters.showingType,
        is_showami: this.filters.is_showami,
      };

      if (this.propertyId) {
        params.property_id = this.propertyId;
      } else if (this.unitId) {
        params.unit_id = this.unitId;
      }

      if (this.filterByAgentId) {
        params.user_id = [this.filterByAgentId];
      }

      return this.api().request('GET', 'tours', {}, params);
    },
    prevPage() {
      this.pagination.page--;
      this.init();
    },
    nextPage() {
      this.pagination.page++;
      this.init();
    },
    initPage1() {
      this.pagination.page = 1;
      this.init();
    },
    toggleFiltersMobile() {
      this.showFiltersMobile = !this.showFiltersMobile;
    },
    toggleFiltersDesktop() {
      this.showFiltersDesktop = !this.showFiltersDesktop;
    },
    visibleColumnsChanged() {
      this.$store.commit('app/SET_DATA_TABLE_CONFIG', {
        name: this.tableName,
        key: 'visibleColumns',
        value: this.visibleColumns,
      });
    },
    openCancelTourConfirm(tour) {
      const tourDiffMinutes = this.moment(tour.tour_at).diff(this.moment(), 'minutes');
      const showamiDeadline = this.getSetting('showami_lead_tour_confirmation_deadline');
      const minEffectiveTime = this.getSetting('pause/deactivation_minimum_effective_time', tour.property.market_id);
      const lessThanMinEffectiveTime = tourDiffMinutes < minEffectiveTime;
      const lessThenShowamiDeadline = tourDiffMinutes < showamiDeadline;
      let message = 'Are you sure you want to cancel this tour?';
      if (lessThanMinEffectiveTime) {
        message += ` It is less than ${minEffectiveTime} minutes away`;
      }

      if (tour.is_showami && lessThenShowamiDeadline) {
        message += `. It is less than ${lessThenShowamiDeadline} minutes away from the Showami deadline. Showami penalties will apply`;
      }

      this.uiConfirm(message).then(() => {
        const url = `tours/${tour.id}/cancel`;

        this.uiLoading();
        this.api().request('POST', url).then(() => {
          this.uiNotify('Tour cancelled successfully');
          this.init(true);
          this.uiLoading(false);
        }).catch(() => {
          this.uiNotify('Error occurred', 'negative');
          this.uiLoading(false);
        });
      });
    },
    get,
  },
};
</script>

<style lang="scss">
    .font-small {
      font-size: small;
    }
    .q-table-container {
        display: flex;
        flex-direction: column;

        .q-table-top,
        .q-table-bottom {
            // like col-auto
            width: auto;
            min-width: 0;
            max-width: 100%;
            flex: 0 0 auto;
        }

        .q-table-middle {
            // like col
            height: auto;
            min-height: 0;
            flex: 10000 1 0%;

            > .q-table > tbody > tr {
                &:nth-child(even) {
                    background: rgba(0, 0, 0, 0.03);
                }

                &:hover {
                    background: rgba(0, 0, 0, 0.06);
                }
            }
        }
    }
</style>
